<template>
  <div class="abcs-select">
    <AbcsSelectItem :icon="icon1" :iconmap="iconmap" @change="onSelectChange('select1', $event)" />
    <AbcsSelectItem :icon="icon2" :iconmap="iconmap" @change="onSelectChange('select2', $event)" />
    <AbcsSelectItem :icon="icon3" :iconmap="iconmap" @change="onSelectChange('select3', $event)" />
  </div>
</template>
<script>
import AbcsSelectItem from "./AbcsSelectItem.vue";

export default {
  name: "AbcsSelect",
  components: { AbcsSelectItem },
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentOption: "",
      select1: "B",
      select2: "B",
      select3: "S",
      iconmap: {
        A: require("@/assets/zs_imgs/zbtj/abcs-select-en-a.png"),
        B: require("@/assets/zs_imgs/zbtj/abcs-select-en-b.png"),
        C: require("@/assets/zs_imgs/zbtj/abcs-select-en-c.png"),
        S: require("@/assets/zs_imgs/zbtj/abcs-select-en-s.png")
      }
    };
  },
  computed: {
    icon1() {
      return this.iconmap[this.select1];
    },
    icon2() {
      return this.iconmap[this.select2];
    },
    icon3() {
      return this.iconmap[this.select3];
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.select1 = newVal[0] || "B";
          this.select2 = newVal[1] || "B";
          this.select3 = newVal[2] || "S";
          // this.calculateCombinationValue();
        }
      },
      immediate: true
    }
  },

  methods: {
    calculateCombinationValue() {
      const combination = `${this.select1}${this.select2}${this.select3}`;

      const letterValues = { c: 1, b: 2, a: 3, s: 4 };
      const letters = combination.toLowerCase().split("");
      let total = 0;
      for (let i = 0; i < 3; i++) {
        const letter = letters[i];
        const positionWeight = i + 1;
        total += positionWeight * letterValues[letter];
      }

      console.log(combination, total + 6);
      this.$emit("change", total + 6, combination);
    },
    onSelectChange(select, value) {
      this[select] = value;
      this.calculateCombinationValue();
    }
  }
};
</script>
<style lang="less" scoped>
.abcs-select {
  display: flex;
  justify-content: space-between;
  width: 100%;
  // column-gap: 2px;
}
</style>
